import { render, staticRenderFns } from "./add_design_card.vue?vue&type=template&id=79838286&scoped=true"
import script from "./add_design_card.vue?vue&type=script&lang=js"
export * from "./add_design_card.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/case_management_add_case.css?vue&type=style&index=0&id=79838286&prod&scoped=true&lang=css&external"
import style1 from "./add_design_card.vue?vue&type=style&index=1&id=79838286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79838286",
  null
  
)

export default component.exports